import { Button } from '@itarget/shared'
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import CurrencyField from '../CurrencyField'
import { useStyles } from './styles'
import { useTranslation } from './translation'
import { useCashbackWallet } from '../../hooks/useCashbackWallet'

const CashbackWallet = ({
  balance = 0,
  totalToSpend = 0,
  balanceUsed = 0,
  cashbackSymbol = 'R$',
  onApplyCashback,
  handleCleanAppliedCashbackWallet,
}) => {
  const styles = useStyles()
  const translation = useTranslation()

  const {
    utilizeWallet,
    amountFromWallet,
    formattedBalance,
    redemptionLimitText,
    maxInsertToSpend,
    handleChangeAmountFromWallet,
    handleChangeCheckboxUtilizeWallet,
    handleApplyCashback,
  } = useCashbackWallet({
    balance,
    totalToSpend,
    balanceUsed,
    cashbackSymbol,
    translation,
    onApplyCashback,
    handleCleanAppliedCashbackWallet,
  })

  return (
    <Box className={styles.container}>
      <Box className={styles.activeWalletContainer}>
        <Typography className={styles.title}>{translation.title}</Typography>

        <FormControlLabel
          control={<Checkbox />}
          checked={utilizeWallet}
          className={styles.checkbox}
          label={translation.checkboxLabel}
          onChange={handleChangeCheckboxUtilizeWallet}
        />
      </Box>

      <Box
        className={`${styles.utilizeWalletContainer} ${
          utilizeWallet ? '' : styles.displayNone
        }`}
      >
        <Box className={styles.balanceContainer}>
          <Typography className={styles.balanceLabel}>
            {translation.balance}
          </Typography>

          <Typography className={styles.balance}>
            <span className={styles.balanceSymbol}>{cashbackSymbol}</span>
            {formattedBalance}
          </Typography>
        </Box>

        <Box className={styles.redemptionLimitContainer}>
          <Typography className={styles.redemptionLimitLabel}>
            {redemptionLimitText}
          </Typography>
        </Box>

        <Box className={styles.redemptionContainer}>
          <Typography className={styles.redemptionLabel}>
            {translation.redemptionLabel}
          </Typography>

          <Box className={styles.interactiveContainer}>
            <CurrencyField
              max={maxInsertToSpend}
              symbol={cashbackSymbol}
              value={amountFromWallet}
              className={styles.currencyField}
              onChange={handleChangeAmountFromWallet}
            />
            <Button
              icon="currency_exchange"
              className={styles.button}
              onClick={handleApplyCashback}
            >
              {translation.applyCashback}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CashbackWallet
